module.exports = "div{width:800px}\n"